/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { BaseCommentBaseWithNormalReplies } from './BaseCommentBaseWithNormalReplies';
import { GeneralFeedbackExtra } from './GeneralFeedbackExtra';
const GeneralFeedbackCommentBaseParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(GeneralFeedbackExtra, BaseCommentBaseWithNormalReplies);
export class GeneralFeedbackCommentBase extends BaseCommentBaseWithNormalReplies {
    static decode(input) {
        return GeneralFeedbackCommentBaseParser.decode(input).map(res => new GeneralFeedbackCommentBase(res));
    }
    static unsafeDecode(input) {
        return GeneralFeedbackCommentBase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GeneralFeedbackCommentBaseParser.encode(data);
    }
    static schema() {
        return GeneralFeedbackCommentBaseParser.schema();
    }
}
